const getters = {
    emailcampaign: (state) => state.emailcampaign,
    emailcampaignid: (state) => state.emailcampaignid,
    loading: state => state.loading
};

export default getters;